import { useState } from "react";
import { Typography, Paper } from "@mui/material";
import CurveFormFields from "./CurveFormFields";
import PropTypes from "prop-types";

const CurveEditForm = ({ initialData, onSubmit }) => {
  const [name, setName] = useState(initialData.name || "");
  const [description, setDescription] = useState(initialData.description || "");
  const [appliesTo, setAppliesTo] = useState(initialData.appliesTo || "target");
  const [active, setActive] = useState(initialData.active || false);
  const [segments, setSegments] = useState(initialData.segments || []);

  const handleSegmentChange = (index, field, value) => {
    const updated = [...segments];
    updated[index][field] = value;
    setSegments(updated);
  };

  const handleTermChange = (segIndex, termIndex, field, value) => {
    const updated = [...segments];
    updated[segIndex].terms[termIndex][field] = value;
    setSegments(updated);
  };

  const addSegment = () => {
    setSegments([
      ...segments,
      {
        segmentOrder: segments.length + 1,
        startKnot: "",
        endKnot: "",
        segmentType: "polynomial",
        terms: [],
        a: "",
        b: "",
        c: "",
      },
    ]);
  };

  const removeSegment = (index) => {
    const updated = [...segments];
    updated.splice(index, 1);
    setSegments(updated);
  };

  const addTerm = (index) => {
    const updated = [...segments];
    if (!updated[index].terms) updated[index].terms = [];
    updated[index].terms.push({ power: "", coefficient: "" });
    setSegments(updated);
  };

  const removeTerm = (segIndex, termIndex) => {
    const updated = [...segments];
    updated[segIndex].terms.splice(termIndex, 1);
    setSegments(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name,
      description,
      appliesTo,
      active,
      segments,
    };

    onSubmit(payload);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Edit Curve
      </Typography>
      <CurveFormFields
        type="edit"
        name={name}
        setName={setName}
        description={description}
        setDescription={setDescription}
        appliesTo={appliesTo}
        setAppliesTo={setAppliesTo}
        active={active}
        setActive={setActive}
        segments={segments}
        handleSegmentChange={handleSegmentChange}
        handleTermChange={handleTermChange}
        handleAddSegment={addSegment}
        handleRemoveSegment={removeSegment}
        handleAddTerm={addTerm}
        handleRemoveTerm={removeTerm}
        handleSubmit={handleSubmit}
      />
    </Paper>
  );
};

CurveEditForm.propTypes = {
  initialData: PropTypes.any,
  onSubmit: PropTypes.func.isRequired,
};

export default CurveEditForm;
